// tslint:disable:max-line-length

import React from "react";
import { Link } from "react-router";

import { GetAtolPdfButton } from "../../../../../shared/components/getAtolPdfButton";
import { stripNewLines } from "../../../../../shared/helpers/stringHelpers";
import { getVisaLinksFragment } from "../utils";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface Props {
  enquiry: IEnquiry;
  currentItinerary: IEnquiryItinerarySummary;
}

export const Booked = ({ enquiry, currentItinerary }: Props) => {
  if (!enquiry.isConnected) {
    return;
  }

  const { emergencyPhoneNumber, address } = enquiry.lto;
  const visaFragment = getVisaLinksFragment(currentItinerary);

  return (
    <div className="next-action-card booked">
      <h3>Thanks for booking!</h3>
      <p>You're now part of the local travel revolution. Before you go, here's some important information you should know:</p>
      <ul>
        <li>
          Your trip is being handled by <strong>{enquiry.lto.name}</strong>. If you have any questions or concerns during your trip, here's how to contact them:<br />
          <span><Link to={WebRoutes.customerEnquiryMessaging(enquiry.id)}>Send a message on TravelLocal</Link> (recommended)</span><br />
          <span><strong>Phone number: </strong> <a href={`tel:${emergencyPhoneNumber}`}>{emergencyPhoneNumber}</a></span><br />
          {address && <span><strong>Office address:</strong> {stripNewLines(address)}</span>}
        </li>
        <li>Please double-check if you require a visa for {visaFragment}. Full advice for British passport holders is <a href="https://www.gov.uk/foreign-travel-advice" target="_blank">available on the UK Government website</a>. Many destinations and airlines require a minimum of six months passport validity.</li>

        {enquiry.atolEligible && (
          <li>Your trip is ATOL protected. <GetAtolPdfButton enquiryId={enquiry.id} itineraryId={enquiry.currentItinerarySummary.id} text="Click here to view your certificate." inline={true} isAnchor={true} /> We recommend that you print this and keep it with you during your holiday.</li>
        )
        }

      </ul>
      <p>If you have any questions about your next steps, don't hesitate to contact us.</p>
    </div>
  );
};
